import axios from "axios";
import qs from "qs";

export default {
  getInitialData(context) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_SUBS}`)
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.dispatch("getList", response.data.subs);
          context.commit("setTotal", response.data.total);
          context.commit("setTotalActive", response.data.totalActive);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getList(context, list) {
    context.commit("setList", list);
  },

  setSortby(context, sortby) {
    context.commit("updateSortby", sortby);
    context.commit("updateTerm", "");
    context.dispatch("getSortList");
  },

  setSortDir(context, sortdir) {
    context.commit("updateSortdir", sortdir);
    context.commit("updateTerm", "");
    context.dispatch("getSortList");
  },

  setOrderby(context, orderby) {
    context.commit("updateOrderby", orderby);
    context.commit("updateTerm", "");
    context.dispatch("getSortList");
  },

  cancelAccount(context, sub) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_SUBS}`,
        qs.stringify({
          subId: sub.id,
          cancel: 1
        })
      )
      .then(res => {
        if (res.data.success === "1") {
          context.commit("setStatus", {
            sub,
            status: 0
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  activateAccount(context, sub) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_SUBS}`,
        qs.stringify({
          subId: sub.id,
          activate: 1
        })
      )
      .then(res => {
        if (res.data.success === "1") {
          context.commit("setStatus", {
            sub,
            status: 1
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  cancelToken(context, sub) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_SUBS}`,
        qs.stringify({
          subId: sub.id,
          cancelToken: 1
        })
      )
      .then(res => {
        if (res.data.success === "1") {
          context.commit("setCanceledToken", {
            sub
          });
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getSortList(context) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_SUBS}`, {
        params: {
          sort: context.state.sortby,
          sortdir: context.state.sortdir,
          orderby: context.state.orderby
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.dispatch("getList", response.data.subs);
          context.commit("setTotal", response.data.total);
          context.commit("setTotalActive", response.data.totalActive);
          context.commit("resetPage");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getTextSearch(context, term) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_SUBS}`, {
        params: {
          sort: "text",
          term
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.dispatch("getList", response.data.subs);
          context.commit("setTotal", response.data.total);
          context.commit("resetPage");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  addResults(context) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_SUBS}`, {
        params: {
          page: context.state.page + 1,
          sort: context.state.sortby,
          sortdir: context.state.sortdir,
          orderby: context.state.orderby
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.commit("addToList", response.data.subs);
          context.commit("addPage");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  openModal(context, sub) {
    context.commit("showModal", sub);
  },

  closeModal(context) {
    context.commit("hideModal");
  },

  updateNextPayment(context, payload) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_SUBS}`,
        qs.stringify({
          subId: payload.subId,
          durType: payload.durationType,
          dur: payload.duration
        })
      )
      .then(res => {
        if (res.data.success === "1") {
          context.commit("setNextPayment", payload);
          context.commit("hideModal");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  sendCharge(context, sub) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_CHARGE}`,
        qs.stringify({
          subId: sub.userdata_id,
          charge: 1
        })
      )
      .then(res => {
        let payload = {
          success: 0,
          message: res.data.responseArray["Description"]
        };

        if (res.data.success === "1") {
          payload["success"] = 1;
        }

        context.commit("chargeMessage", payload);
      })
      .catch(e => {
        console.log(e);
      });
  },

  closeMessage(context) {
    context.commit("hideMessage");
  },

  // refs
  getRefList(context) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_REFS}`, {
        params: {
          list: 1
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.commit("setRefList", response.data.refs);
          context.commit("setTotal", response.data.total);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  deactivateRef(context, ref) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_REFS}`,
        qs.stringify({
          activate: 0,
          refId: ref.id
        })
      )
      .then(res => {
        if (res.data.success === 1) {
          context.commit("setRefNotActive", ref.id);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  activateRef(context, ref) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_REFS}`,
        qs.stringify({
          activate: 1,
          refId: ref.id
        })
      )
      .then(res => {
        if (res.data.success === 1) {
          context.commit("setRefActive", ref.id);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  saveNewRef(context, ref) {
    let refActive = 0;
    let payload = {};
    if (ref.active) {
      refActive = 1;
    }

    if (ref.createUser === "1") {
      payload = {
        newRef: 1,
        newUser: 1,
        text: ref.text,
        active: refActive,
        newPassword: ref.newUser.password,
        newEmail: ref.newUser.email,
        newFullname: ref.newUser.fullname
      };
    } else {
      payload = {
        newRef: 1,
        uid: ref.uid,
        text: ref.text,
        active: refActive
      };
    }

    axios
      .post(`${process.env.VUE_APP_ADMIN_REFS}`, qs.stringify(payload))
      .then(res => {
        if (res.data.success === 1) {
          context.commit("setNewRef", res.data.ref);
          context.commit("openNewRef");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getRefItem(context, id) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_REFS}`, {
        params: {
          refId: id
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === "1") {
          context.commit("setCurrentRef", response.data.ref);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getCupons(context) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_CUPONS}`, {
        params: {
          list: "show"
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === 1) {
          context.commit("setCupons", response.data.cupons);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  createCupon(context) {
    context.commit("toggleCuponForm");
    context.commit("newCuponForm");
  },
  closeCuponForm(context) {
    context.commit("resetCuponForm");
  },

  editCupon(context, cupon) {
    context.commit("updateCupon", cupon);
    context.commit("toggleCuponForm");
  },
  saveCupon(context, cupon) {
    let payload = {
      ...cupon
    };

    payload.cupon_id = payload.id;
    delete payload.id;
    if (cupon.mode && cupon.mode === "new") {
      payload.create = 1;
    } else {
      payload.edit = 1;
    }

    axios
      .post(`${process.env.VUE_APP_ADMIN_CUPONS}`, qs.stringify(payload))
      .then(res => {
        if (res.data.success === 1 && res.data.newCupon) {
          context.commit("addToCuponList", res.data.newCupon);
          context.commit("toggleCuponForm");
          context.commit("resetCuponForm");
        }

        if (res.data.success === 1 && res.data.updated) {
          context.commit("updateCuponList", res.data.updated);
          context.commit("toggleCuponForm");
          context.commit("resetCuponForm");
        }

        if (res.data.success === 0) {
          context.commit("cuponError");
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  deleteCupon(context, payload) {
    axios
      .post(
        `${process.env.VUE_APP_ADMIN_CUPONS}`,
        qs.stringify({
          delete: payload.id
        })
      )
      .then(res => {
        if (res.data.success === 1) {
          context.commit("redmoveCupon", payload.index);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  getCuponUsers(context, cupon) {
    if (cupon) {
      axios
        .post(
          `${process.env.VUE_APP_ADMIN_SUBS}`,
          qs.stringify({
            cuponUsers: cupon.used_by
          })
        )
        .then(res => {
          if (res.data.success === "1") {
            context.commit("setCuponUsers", res.data.subs);
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  },

  getCupon(context, cuponId) {
    axios
      .get(`${process.env.VUE_APP_ADMIN_CUPONS}`, {
        params: {
          list: "show"
        }
      })
      .then(response => {
        if (response.data.auth === 1 && response.data.success === 1) {
          context.commit("setCupons", response.data.cupons);

          const cupon = context.getters.getCuponById(cuponId);

          context.dispatch("getCuponUsers", cupon);
        }
      })
      .catch(e => {
        console.log(e);
      });
  },

  fetchStats(context) {
    context.commit("setStatsLoading", true);
    axios
      .get(`${process.env.VUE_APP_ADMIN_STATS}`, {})
      .then(response => {
        context.commit("setStats", response.data);
        context.commit("setStatsLoading", false);
      })
      .catch(e => {
        console.log(e);
      });
  }
};
